import { render, staticRenderFns } from "./DialogDefault.vue?vue&type=template&id=f1339f7e&scoped=true"
import script from "./DialogDefault.vue?vue&type=script&lang=js"
export * from "./DialogDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1339f7e",
  null
  
)

export default component.exports